import { useEffect, useState, useRef } from "react";

export const useCountdownRefetch = (
  intervalSeconds: number,
  onRefetch: () => void,
  enabled = true
) => {
  const [refetchTimestamp, setRefetchTimestamp] = useState(new Date());
  const [secondsLeft, setSecondsLeft] = useState(intervalSeconds);
  const [progress, setProgress] = useState(0); // from 0 to 100
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (!enabled) {
      // Pause the interval
      if (timerRef.current) clearInterval(timerRef.current);
      timerRef.current = null;
      return;
    }
    timerRef.current = setInterval(() => {
      setSecondsLeft((prev) => {
        if (prev <= 1) {
          setRefetchTimestamp(new Date());
          onRefetch?.();
          return intervalSeconds;
        }
        return prev - 1;
      });

      setProgress((prev) => {
        const next = prev + 100 / intervalSeconds;
        return next >= 100 ? 0 : next;
      });
    }, 1000);

    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [enabled, intervalSeconds, onRefetch]);

  return {
    secondsLeft,
    progress, // from 0 to 100
    refetchTimestamp,
  };
};
